import script from "./HrStandardDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./HrStandardDialog.vue?vue&type=script&setup=true&lang=js"

import "./HrStandardDialog.vue?vue&type=style&index=0&id=3c1e290f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c1e290f"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
